// Font
export const headingFont = 'Montserrat'
export const textFont = 'Open Sans'

// Size
export const baseFontSizeLarge = '16px'
export const baseFontSizeSmall = '12px'
